module.exports = __webpack_public_path__ + "img/p67.14a74fa8.jpg";